import { Injectable } from '@angular/core';
import { BillingInvoiceEditService } from '../billing-invoice/billing-invoice-edit.service';
import { InvoiceNumberBookPoint } from 'src/app/model/invoice-number-book-point';
import { BillingInvoice } from 'src/app/model/billing/billing-invoice';
import { BillingInvoiceItemEditInfo } from 'src/app/model/billing/billing-invoice-item-edit-info';
import { BillingInvoiceCreateResponse } from 'src/app/model/billing/billing-invoice-create-response';
import { BillingInvoiceEditInfo } from 'src/app/model/billing/billing-invoice-edit-info';
import { ReportViewer } from 'src/app/model/report-viewer';
import { InvoiceType } from '../../../enums/invoice-type.enum';
import { ClientSearch } from '../../../model/client-search';

@Injectable({
  providedIn: 'root'
})
export class BillingInvoiceManualEditService extends BillingInvoiceEditService {

  invoiceTypeId: number;
  sectorId: number;

  isVisibleDatesFromTo(): boolean {
    return true;
  }
 

  isVisibleIsRejectedOptions(): boolean {
    return this.invoiceTypeId === InvoiceType.Debit;
  }

  isVisibleBillingInvoiceItemManual(): boolean {
    return true;
  }

  isVisibleBillingInvoiceItemEntity(): boolean {
    return false;
  }

  isVisibleBillingInvoiceItemEntityCredit(): boolean {
    return false;
  }

  noDeleteItemManual(): boolean {
    return false;
  }

  isVisibleCirculacionAbierta(): boolean {
    return this.invoiceTypeId !== InvoiceType.Debit;
  }

  isVisibleBillingInvoiceAssociate(): boolean {
    return this.invoiceTypeId === InvoiceType.Debit;
  }

  setBillingInvoiceManualParams(sectorId: number,
    invoiceTypeId: number) {

     this.sectorId = sectorId;
     this.invoiceTypeId = invoiceTypeId;
  }

  setBillingInvoiceParams(sectorId: number,
    preBillingId: number, invoiceTypeId: number) {

    throw new Error('Method not implemented.');
  }

  setBillingInvoiceCreditParams(sectorId: number,
    billingInvoiceId: number) {

    throw new Error('Method not implemented.');
  }

  async billingInvoiceCreate(clientSearch: ClientSearch,
      invoiceNumberBookPoint: InvoiceNumberBookPoint,
      billingInvoice: BillingInvoice,
      medicalAppointmentProcedureExcludeIds: number[],
      items: BillingInvoiceItemEditInfo[]): Promise<BillingInvoiceCreateResponse> {

    return await this.billingInvoiceManualService.billingInvoiceCreate(
      clientSearch, invoiceNumberBookPoint, billingInvoice, items);
  }

    getParentInvoiceCompleteNumber(): string {
    return '';
  }

  getInvoiceTypeId(): number {

    return this.invoiceTypeId;
  }

  async getBillingInvoiceEditInfo(): Promise<BillingInvoiceEditInfo> {

    return await this.billingInvoiceManualService
      .getBillingInvoiceEditInfo( this.sectorId );
  }

  async getBillingInvoiceReport(billingInvoiceId: number): Promise<ReportViewer> {

    return await this.billingInvoiceManualService
      .getBillingInvoiceReport( billingInvoiceId );
  }

  getBillingInvoiceItemEditInfos(): Promise<BillingInvoiceItemEditInfo[]> {

    return Promise.resolve([]);
  }

  async calculateBillingInvoice(billingInvoice: BillingInvoice,
    items: BillingInvoiceItemEditInfo[]): Promise<BillingInvoice> {

      const calculate = await this.billingInvoiceAmountService
        .calculateBillingInvoiceAmount( 
          billingInvoice.ClientSearch,
          billingInvoice.InvoicePoint,
          items);

      billingInvoice.InvoiceTaxes = calculate.InvoiceTaxes;
      billingInvoice.Amount = calculate.Amount;
      billingInvoice.AmountWithTax = calculate.AmountWithTax;

      return billingInvoice;

  }
}
